export type KioskFlow = 'idle' | 'check-in' | 'check-out'
export type KioskType = 'check-in' | 'jobs-board'

export type KioskSessionPeripherals =
  | 'charger'
  | 'mouse'
  | 'bag'
  | 'other'

export interface KioskSessionFormData {
  customerId?: string
  fullName?: string
  contactPhone?: string
  checkedOutName?: string
  checkedOutPhone?: string
  contactEmail?: string
  contactAddress?: string
  invoiceName?: string
  invoiceAddress?: string
  invoiceVat?: string
  invoiceEmail?: string
  invoicePhone?: string

  deviceType?: string
  deviceTypeOther?: string
  deviceDescription?: string
  devicePassword?: string
  fault?: string
  peripherals?: KioskSessionPeripherals[]
  peripheralsOther?: string
}

export const KIOSK_STEP_TITLES = [
  'Customer Details',
  'Device Details',
  'Terms & Signature',
] as const

export const KIOSK_STEP_CUSTOMER = 1
export const KIOSK_STEP_DEVICE = 2
export const KIOSK_STEP_TERMS = 3

export type KioskStep =
  | typeof KIOSK_STEP_CUSTOMER
  | typeof KIOSK_STEP_DEVICE
  | typeof KIOSK_STEP_TERMS

export type KioskStepIndex = 0 | 1 | 2

export interface Kiosk {
  id: string
  createdAt: string
  updatedAt: string
  name: string
  label: string
  friendlyName?: string
}

export interface KioskSession {
  id: string
  createdAt: string
  updatedAt: string
  kioskId: string
  kioskType: KioskType
  flow: KioskFlow
  currentStep: number
  formData: KioskSessionFormData
  jobId?: string
  lastCompletedFlow?: 'check-in' | 'check-out'
  /** Staff user who started the active check-in/out flow from the control panel; stamped onto the job as checkedInBy/checkedOutBy at submit. */
  startedBy?: string
  pairingCode?: string
  pairingCodeExpiresAt?: string
  /** Client id of the browser that produced the latest write; used to ignore own realtime echoes. */
  lastUpdateOrigin?: string
}

export interface Document {
  id: string
  createdAt: string
  updatedAt: string
  key: string
  title: string
  body: string
}

export const KIOSK_DEVICE_TYPE_OPTIONS = [
  'Laptop',
  'Desktop',
  'Tablet',
  'Phone',
  'Printer',
  'Multiple Devices',
  'Other',
] as const
